import React from 'react';
import Seo from '../seo/Seo';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    if (process.env.NODE_ENV === 'development') {
      // eslint-disable-next-line no-console
      console.error('[ErrorBoundary]', error, info);
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <>
          <Seo title="Ett fel uppstod" description="Ett oväntat fel inträffade." noindex />
          <div style={{ padding: '2rem', textAlign: 'center' }}>
            <h1>Oj! Något gick fel.</h1>
            <p>Vi jobbar på att fixa det. Prova att uppdatera sidan.</p>
          </div>
        </>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
